import { EnvironmentProviders } from '@angular/core';
import { environment } from 'environments/environment';
import {
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  provideKeycloak,
} from 'keycloak-angular';

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const graphqlBearerCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`^${escapeRegExp(environment.graphql.academy_endpoint)}.*$`, 'i'),
});

const storageBearerCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`^${escapeRegExp(environment.storage.storage_endpoint)}.*$`, 'i'),
});

export const provideKeycloakAngular = (): EnvironmentProviders =>
  provideKeycloak({
    config: {
      url: environment.keyCloak.urlAuthKeycloak,
      realm: environment.keyCloak.realmKeycloak,
      clientId: environment.keyCloak.clientId,
    },
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: `${window.location.origin}/assets/silent-check-sso.html`,
      flow: 'standard',
      scope: environment.keyCloak.scope,
      redirectUri: window.location.origin,
      checkLoginIframe: false,
    },
    providers: [
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [graphqlBearerCondition, storageBearerCondition],
      },
    ],
  });
